module.exports = __webpack_public_path__ + "static/img/108.3df83ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/108.jpg
// module id = EBhT
// module chunks = 2